import React, { useEffect, useRef, useState } from "react"
import { Link } from "gatsby"
import { FiMenu, FiX } from "react-icons/fi"

import { Mark } from "./mark"
import ThemeToggle from "./theme-toggle"

const Header = () => {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const barRef = useRef(null)
  const menuButtonRef = useRef(null)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  // On small screens the nav is a dropdown; close it on Escape or on a tap
  // outside the bar.
  useEffect(() => {
    if (!menuOpen) return undefined

    const onKeyDown = event => {
      if (event.key !== "Escape") return
      setMenuOpen(false)
      menuButtonRef.current.focus()
    }
    const onPointerDown = event => {
      if (!barRef.current.contains(event.target)) setMenuOpen(false)
    }
    document.addEventListener("keydown", onKeyDown)
    document.addEventListener("pointerdown", onPointerDown)
    return () => {
      document.removeEventListener("keydown", onKeyDown)
      document.removeEventListener("pointerdown", onPointerDown)
    }
  }, [menuOpen])

  const closeMenu = () => setMenuOpen(false)

  const classes = ["site-header"]
  if (scrolled) classes.push("is-scrolled")
  if (menuOpen) classes.push("is-open")

  return (
    <header className={classes.join(" ")}>
      <div className="site-header__bar" ref={barRef}>
        <Link to="/" className="brand" aria-label="Euroweb, home">
          <Mark className="brand__mark" />
          <span className="brand__name">Euroweb</span>
        </Link>
        {/* Sits before the nav so the links follow it in tab order. */}
        <button
          type="button"
          ref={menuButtonRef}
          className="menu-button"
          aria-label="Menu"
          aria-expanded={menuOpen}
          aria-controls="site-nav"
          onClick={() => setMenuOpen(open => !open)}
        >
          {menuOpen ? (
            <FiX aria-hidden="true" />
          ) : (
            <FiMenu aria-hidden="true" />
          )}
        </button>
        <nav id="site-nav" className="site-nav" aria-label="Main">
          <a href="/#services" onClick={closeMenu}>
            Services
          </a>
          <a href="/#contact" onClick={closeMenu}>
            Contact
          </a>
        </nav>
        <ThemeToggle />
      </div>
    </header>
  )
}

export default Header
